module.exports = __webpack_public_path__ + "img/file-sync.11b2a5b4.svg";